// legalStructureManagment

export interface StaffMember {
  id?         : number;
  userId      : number;
  firstname   : string;
  lastname    : string;
  jobTitle    : string;
  email       : string;
  phoneNumber : string;
}

export interface BusinessDocument {
  id?          : number;
  creationDate : Date;
  name         : string;
  fileToUpload : File|null
  fileName     : string;
  fileType     : string;
}


export interface LegalStructure {
  id                                       : number;
  creationDate                             : Date;                     
  tradeName                                : string;
  companyName                              : string;
  legalForm                                : string;
  businessRegistrationNumber               : string;
  businessActivityCode                     : string;
  businessSector                           : string;
  businessActivityDetails                  : string;
  address                                  : string;
  address2                                 : string;
  address3                                 : string;                      
  zipCode                                  : string;
  city                                     : string;
  country                                  : string;
  phoneNumber                              : string;
  handledByAgentId                         : number;
  VATnumber                                : string;
  administrativeValidationDate             : Date | null;
  administrativeValidationAgentId          : number; 
  financialValidationDate                  : Date | null;
  financialValidationAgentId               : number;      
  financialValidationBalanceValue          : number;
  financialValidationBalanceExpirationDate : Date | null;
  staffMembers                             : StaffMember[];             
  businessDocuments                        : BusinessDocument[];           
  latitude                                 : number;                         
  longitude                                : number;
}

export const initializedStaffMember = (): StaffMember => ({
  id          : 0,
  userId      : 0,
  firstname   : '',
  lastname    : '',
  jobTitle    : '',
  email       : '',
  phoneNumber : '',
});

export const initializedBusinessDocument = (): BusinessDocument => ({
  id           : 0,
  creationDate : new Date(),
  name         : '',
  fileToUpload : null,
  fileName     : '',
  fileType     :  '',
});

export const initializedLegalStructure = (): LegalStructure => ({
  id                                       : 0,
  creationDate                             : new Date(),                
  tradeName                                : '',
  companyName                              : '',
  legalForm                                : '',
  businessRegistrationNumber               : '',
  businessActivityCode                     : '',
  businessSector                           : '',
  businessActivityDetails                  : '',
  address                                  : '',
  address2                                 : '',
  address3                                 : '',                            
  zipCode                                  : '',
  city                                     : '',
  country                                  : '',
  phoneNumber                              : '',
  handledByAgentId                         : 0,
  VATnumber                                : '',
  administrativeValidationDate             : null,
  administrativeValidationAgentId          : 0,
  financialValidationDate                  : null,
  financialValidationAgentId               : 0,
  financialValidationBalanceValue          : 0,
  financialValidationBalanceExpirationDate : null,
  staffMembers                             : [],                        
  businessDocuments                        : [],                 
  latitude                                 : 0,
  longitude                                : 0,
});

export interface GetLegalStructureListParams {
  beginningDate? : Date;
  endingDate?    : Date;
  filter?        : string;
}
